import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AlertMessage from "../../components/AlertMessage";
import { loadUSDTWalletBalance, requestUSDTWithdrawal, sendOtpWithdrawal,loadDashboardData } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";
import { Link } from "react-router-dom";

const RequestWithdrawal = () => {
  const [reactalert, setAlert] = useState({ type: "", message: "" });
  const [fundBalance, setFundBalance] = useState(0);
  //const [wallet, setWallet] = useState("");
  const [reward, setReward] = useState("");
  const [remark, setRemark] = useState("");
  const [otpSent, setOtpSent] = useState(true);
  const [otp, setOtp] = useState("");
  const [serverOtp, setServerOtp] = useState("");
  const [loading, setLoading] = useState(false);
    const [emailId, setEmailId] = useState("")
    const wallet = localStorage.getItem("wallet");
 const [emailMissing, setEmailMissing] = useState(false);
  const { token, fetchToken } = useToken();

  const formatBalance = (balance) => balance ? parseFloat(balance).toLocaleString() : "";

  useEffect(() => {
    const initialize = async () => {
      try {
        const currentToken = token || (await fetchToken());
        if (!currentToken) return;
        const loginToken = localStorage.getItem("LoginToken");
        if (!loginToken) {
          setAlert({ type: "error", message: "Session Expired. Please login again." });
          return;
        }
        const response = await loadUSDTWalletBalance(currentToken, loginToken, 2);
        setFundBalance(response?.data || 0);
          // Fetch email from API
        const profileResponse = await loadDashboardData(currentToken, loginToken);
        const emailFromApi = profileResponse?.Dashboard?.EMAILID || ""; // adjust if API structure is different
        setEmailId(emailFromApi);
        if (!emailFromApi) setEmailMissing(false);
      } catch {
        setFundBalance(0);
      }
    };
    initialize();
  }, [token, fetchToken]);

  const handleSendOtp = async () => {
    if (!wallet.trim()) {
      setAlert({ type: "error", message: "Please enter wallet address first!" });
      return;
    }
     if (!reward) {
      setAlert({ type: "error", message: "Please enter Amount!" });
      return;
    }
    setLoading(true);
    try {
      const currentToken = token || (await fetchToken());
      if (!currentToken) return;
      const loginToken = localStorage.getItem("LoginToken");
      const data = await sendOtpWithdrawal(currentToken, loginToken,wallet,"1",reward);
      if (data?.status && data?.data === "success") {
        setAlert({ type: "success", message: "OTP sent to your email!" });
        setOtpSent(true);
        setServerOtp(data.EmailID || "");
      } else {
        setAlert({ type: "error", message: data?.data || "Failed to send OTP!" });
      }
    } catch {
      setAlert({ type: "error", message: "Something went wrong while sending OTP." });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    // if (!otp) {
    //   setAlert({ type: "error", message: "Please enter OTP!" });
    //   return;
    // }
    // if (otp !== serverOtp) {
    //   setAlert({ type: "error", message: "Invalid OTP!" });
    //   return;
    // }
 if (!wallet.trim()) {
      setAlert({ type: "error", message: "Please enter wallet address first!" });
      return;
    }
     if (!reward) {
      setAlert({ type: "error", message: "Please enter Amount!" });
      return;
    }
    setLoading(true);
    try {
      const currentToken = token || (await fetchToken());
      if (!currentToken) return;
      const loginToken = localStorage.getItem("LoginToken");
      const data = await requestUSDTWithdrawal(currentToken, loginToken, 2, wallet, reward);
      if (data?.status && data?.data === "success") {
        setAlert({ type: "success", message: "Withdrawal Request Submitted Successfully!" });
        setReward("");
      } else {
        setAlert({ type: "error", message: data?.data || "Withdrawal Failed!" });
      }
    } catch {
      setAlert({ type: "error", message: "Something went wrong while submitting request." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="buyshheikh-page">
          <div className="pageTitle">USDT Withdrawal Request</div>
          <div className="card mb-3">
           <div className="card-body">
             

              <div className="row">
                <div className="col-lg-6">
                  {/* Fund Balance Card */}
                  <div className="fund-card text-white mb-3">
                    <div className="d-flex align-items-center p-3">
                      <div className="coin-icon me-3">🪙</div>
                      <div>
                        <h5 className="mb-1">Your Fund Balance</h5>
                        <p className="balance-amount mb-0">{formatBalance(fundBalance)} USDT</p>
                        <small className="text-white-50">Available to withdraw</small>
                      </div>
                    </div>
                  </div>

   
  {/* Wallet Address */}
  <div className="mb-3">
    <label htmlFor="address" className="form-label">Wallet Address</label>
    <input
      type="text"
      className="form-control form-control-new"
      id="address"
      placeholder="Enter your withdrawal address"
      value={wallet}
      disabled
      required
      //readOnly={otpSent} // <-- readonly after OTP sent
    />
  </div>

  {/* Value */}
  <div className="mb-3">
    <label htmlFor="value" className="form-label">Value</label>
    <input
      type="number"
      className="form-control form-control-new"
      id="value"
      placeholder="Enter amount to withdraw"
      value={reward}
      onChange={(e) => setReward(e.target.value)}
      required
      min="1"
      max={fundBalance}
      //readOnly={otpSent} // <-- readonly after OTP sent
    />
  </div>

  {/* Remark */}
  {/* <div className="mb-3">
    <label htmlFor="remark" className="form-label">Remark</label>
    <textarea
      className="form-control form-control-new"
      id="remark"
      placeholder="Add any remarks (optional)"
      value={remark}
      onChange={(e) => setRemark(e.target.value)}
      rows="3"
      style={{ height: "170px" }}
    ></textarea>
  </div> */}

  {/* Check Email */}
  {emailMissing && (
    <div className="mb-3 text-danger">
      To proceed with your withdrawal request, please update and verify your email id first.
      <Link to="/buy-packages/myprofile" className="btn btn-sm btn-primary ms-2">
        Update Email
      </Link>
    </div>
  )}

  {reactalert.message && (
    <AlertMessage
      type={reactalert.type}
      message={reactalert.message}
      onClose={() => setAlert({ type: "", message: "" })}
    />
  )}



  {/* Buttons */}
  <div className="text-center">
    {!otpSent && !emailMissing ? (
      <button
        type="button"
        className="btn btn-warning"
        onClick={handleSendOtp}
        disabled={loading}
      >
        {loading ? "Sending OTP..." : "Send OTP 🚀"}
      </button>
    ) : (
      !emailMissing && (
        <>
          <button
            className="btn btn-success me-2"
            disabled={loading}
            onClick={handleSubmit}
         
          >
            {loading ? "Submitting..." : "Submit Request 🚀"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => window.location.reload()} // <-- refresh / cancel
          >
            Cancel
          </button>
        </>
      )
    )}
  </div>


                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestWithdrawal;
